import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { FaEdit, FaTrash, FaComments, FaFileInvoice, FaStar, FaComment, FaCog, FaChartLine, FaMoneyBillWave, FaClipboardCheck, FaVideo, FaDownload, FaEllipsisV, FaTimes, FaEye, FaUserSecret, FaThumbtack, FaUsers, FaFilter, FaChevronUp, FaChevronDown, FaSearch, FaFileExcel, FaUserShield } from "react-icons/fa";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import io from 'socket.io-client';
import axios from 'axios';
import EditClientModal from "./EditClientModal";
import ClientPagination from "./ClientPagination";
import ClientFilters from "./ClientFilters";
import ClientMenuModal from "./ClientMenuModal";
import QuickPaymentModal from "./QuickPaymentModal";
import Chatbox from "./Chatbox";
import ChecklistModal from "./ChecklistModal";
import AdminStep1ChecklistModal from "./AdminStep1ChecklistModal";
import Step3CustomTableModal from "../../components/Step3CustomTableModal";
import Step3SubmittedDataModal from "../../components/Step3SubmittedDataModal";
import ExportUserModal from "./ExportUserModal";
import ExportExcelModal from "./ExportExcelModal";
import SkeletonLoader from "../../components/ui/SkeletonLoader";
import PageHeader from "../../components/ui/PageHeader";
import { useToast } from "../../context/ToastContext";
import { exportClientServicesToExcel } from "../../utils/excelExportUtils";

const ClientManagement = () => {
  const [users, setUsers] = useState([]);
  const [onlineUserIds, setOnlineUserIds] = useState([]);

  // Quill editor configuration
  const quillRef = useRef(null);

  // Quill modules configuration
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': ['sans-serif', 'serif', 'monospace'] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'bullet', 'indent',
    'align', 'link'
  ];

  const [filteredUsers, setFilteredUsers] = useState([]);
  const [toggleLoading, setToggleLoading] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editFormData, setEditFormData] = useState({ name: "", email: "" });
  const [chatUser, setChatUser] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [selectedMenuUser, setSelectedMenuUser] = useState(null);
  const [menuInitialMemberIndex, setMenuInitialMemberIndex] = useState(-1);
  const [employeeFilter, setEmployeeFilter] = useState("all");
  const [stepFilter, setStepFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [employees, setEmployees] = useState([]);
  const [activeTab, setActiveTab] = useState("primary");
  const [showStepModal, setShowStepModal] = useState(false);
  const [selectedStepUser, setSelectedStepUser] = useState(null);
  const [selectedStep, setSelectedStep] = useState(2);
  const [userSteps, setUserSteps] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage] = useState(15);
  const [paymentFilter, setPaymentFilter] = useState("all");
  const [serviceFilter, setServiceFilter] = useState("all");
  const [showQuickPaymentModal, setShowQuickPaymentModal] = useState(false);
  const [quickPaymentData, setQuickPaymentData] = useState(null);
  const [selectedUserForPayment, setSelectedUserForPayment] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [sending, setSending] = useState(false);
  const [sendProgress, setSendProgress] = useState(0);
  const [showHistory, setShowHistory] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [emailLogs, setEmailLogs] = useState([]);
  const [historyError, setHistoryError] = useState("");
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [checklistUser, setChecklistUser] = useState(null);
  const [checklistMemberIndex, setChecklistMemberIndex] = useState(-1);
  const [checklistFormType, setChecklistFormType] = useState("");
  const [checklistMode, setChecklistMode] = useState("preview");
  const [showStep1ChecklistModal, setShowStep1ChecklistModal] = useState(false);
  const [step1ChecklistUser, setStep1ChecklistUser] = useState(null);
  const [step1ChecklistMemberIndex, setStep1ChecklistMemberIndex] = useState(-1);
  const [taxYearStart, setTaxYearStart] = useState("");
  const [taxYearEnd, setTaxYearEnd] = useState("");
  const [dueDateStart, setDueDateStart] = useState("");
  const [dueDateEnd, setDueDateEnd] = useState("");
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [showStep3CustomTableModal, setShowStep3CustomTableModal] = useState(false);
  const [step3IsEditMode, setStep3IsEditMode] = useState(false);
  const [showStep3SubmittedDataModal, setShowStep3SubmittedDataModal] = useState(false);
  const [step3User, setStep3User] = useState(null);
  const [step3MemberIndex, setStep3MemberIndex] = useState(null);
  const [step3CustomTable, setStep3CustomTable] = useState(null);
  const [selectionMode, setSelectionMode] = useState(false);
  const [showFiltersPanel, setShowFiltersPanel] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportUser, setExportUser] = useState(null);
  const [isAllExport, setIsAllExport] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleteConfirmationName, setDeleteConfirmationName] = useState("");
  const [feedbackViewData, setFeedbackViewData] = useState({ isOpen: false, title: "", content: "" });
  const [showMemberDeleteModal, setShowMemberDeleteModal] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [memberDeleteConfirmationName, setMemberDeleteConfirmationName] = useState("");
  const [ratingFilter, setRatingFilter] = useState("all");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useToast();

  const chatUserRef = useRef(null);
  useEffect(() => {
    chatUserRef.current = chatUser;
  }, [chatUser]);

  const sortUsersList = (usersList) => {
    return [...usersList].sort((a, b) => {
      if (a.isPinned && !b.isPinned) return -1;
      if (!a.isPinned && b.isPinned) return 1;
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  const handleTogglePin = async (userId) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users/${userId}/toggle-pin`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) throw new Error("Failed to toggle pin status");
      const data = await response.json();
      
      setUsers(prevUsers => {
        const updated = prevUsers.map(user => 
          user._id === userId ? { ...user, isPinned: data.user.isPinned } : user
        );
        return sortUsersList(updated);
      });
    } catch (err) {
      console.error("Error toggling pin:", err);
      alert(err.message);
    }
  };

  // Real-time online status tracking
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/online-users`)
      .then(res => {
        if (res.data.success && Array.isArray(res.data.onlineUserIds)) {
          setOnlineUserIds(res.data.onlineUserIds);
        }
      })
      .catch(err => console.error('Error fetching online users in ClientManagement:', err));

    const socket = io(process.env.REACT_APP_API_BASE_URL);
    socket.emit('joinRoom', 'admin');
    socket.emit('getOnlineUsers');

    socket.on('onlineUsersList', (userIds) => {
      setOnlineUserIds(userIds || []);
    });

    socket.on('userOnlineStatus', ({ userId, isOnline }) => {
      setOnlineUserIds(prev => {
        if (isOnline) {
          return prev.includes(userId) ? prev : [...prev, userId];
        } else {
          return prev.filter(id => id !== userId);
        }
      });
    });


    return () => {
      socket.disconnect();
    };
  }, []);

  const handleToggleVerify = async (userId) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users/${userId}/toggle-verify`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) throw new Error("Failed to toggle verification status");
      const data = await response.json();
      
      setUsers(prevUsers => prevUsers.map(user => 
        user._id === userId ? { ...user, isVerified: data.user.isVerified } : user
      ));
      setFilteredUsers(prevUsers => prevUsers.map(user => 
        user._id === userId ? { ...user, isVerified: data.user.isVerified } : user
      ));
      setSelectedMenuUser(prev => (prev && prev._id === userId ? { ...prev, isVerified: data.user.isVerified } : prev));
    } catch (err) {
      console.error("Error toggling verification:", err);
      alert(err.message);
    }
  };


  useEffect(() => {
    fetchUsers();
    fetchEmployees();
  }, []);

  // Deep linking hook for notifications
  useEffect(() => {
    if (users.length > 0) {
      const chatUserId = searchParams.get("chatUserId");
      const checklistUserId = searchParams.get("checklistUserId");
      const checklistId = searchParams.get("checklistId");
      const checklistType = searchParams.get("checklistType");

      if (chatUserId) {
        const user = users.find(u => u._id === chatUserId);
        if (user) {
          setChatUser(user);
          const params = new URLSearchParams(searchParams);
          params.delete("chatUserId");
          setSearchParams(params, { replace: true });
        }
      } else if (checklistId && checklistUserId) {
        const user = users.find(u => u._id === checklistUserId);
        if (user) {
          // If it's a step 1 checklist, open that modal instead
          if (checklistType === 'prepare' && (checklistId.includes('step1') || checklistType === 'step1')) {
            setStep1ChecklistUser(user);
            setStep1ChecklistMemberIndex(-1);
            setShowStep1ChecklistModal(true);
          } else if (checklistType === 'usa') {
            setStep1ChecklistUser(user);
            setStep1ChecklistMemberIndex(-1);
            setShowStep1ChecklistModal(true);
          } else {
            setChecklistUser(user);
            setChecklistFormType(checklistType || "");
            setChecklistMode("review");
            setShowChecklistModal(true);
          }
          const params = new URLSearchParams(searchParams);
          params.delete("checklistUserId");
          params.delete("checklistId");
          params.delete("checklistType");
          setSearchParams(params, { replace: true });
        }
      }
    }
  }, [users, searchParams, setSearchParams]);
  
  const prevShowMenu = useRef(false);
  const hasRestored = useRef(false);

  // Side Menu Persistence Logic
  useEffect(() => {
    if (users.length > 0 && !hasRestored.current) {
      const menuUserId = searchParams.get("menuUserId");
      const menuTab = searchParams.get("menuTab");

      if (menuUserId && !showMenu) {
        const user = users.find(u => u._id === menuUserId);
        if (user) {
          setSelectedMenuUser(user);
          setSelectedStepUser(user);
          if (menuTab) setActiveTab(menuTab);
          setShowMenu(true);
        }
      }
      hasRestored.current = true;
    }
  }, [users, searchParams]);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (showMenu && selectedMenuUser) {
      if (params.get("menuUserId") !== selectedMenuUser._id || params.get("menuTab") !== activeTab) {
        params.set("menuUserId", selectedMenuUser._id);
        params.set("menuTab", activeTab);
        setSearchParams(params, { replace: true });
      }
    } else if (prevShowMenu.current && !showMenu && params.has("menuUserId")) {
      params.delete("menuUserId");
      params.delete("menuTab");
      setSearchParams(params, { replace: true });
    }
    prevShowMenu.current = showMenu;
  }, [showMenu, selectedMenuUser, activeTab, searchParams, setSearchParams]);

  useEffect(() => {
    filterUsers();
  }, [
    users,
    employeeFilter,
    stepFilter,
    searchQuery,
    paymentFilter,
    serviceFilter,
    ratingFilter,
    taxYearStart,
    taxYearEnd,
    dueDateStart,
    dueDateEnd,
    userSteps,
  ]);

  const fetchUsers = async () => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/admin-login");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to fetch users");

      const data = await response.json();
      const sortedUsers = sortUsersList(data);
      setUsers(sortedUsers);
      sortedUsers.forEach((user) => {
        fetchUserSteps(user._id);
        fetchUserMemberSteps(user._id, user);
      });
      setFilteredUsers(sortedUsers);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/employee/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to fetch employees");

      const data = await response.json();
      setEmployees(data);
    } catch (error) {
      setError(error.message);
    }
  };

  const matchesDateRange = (value, startDate, endDate) => {
    if (!value) return false;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return false;
    if (startDate && date < startDate) return false;
    if (endDate && date > endDate) return false;
    return true;
  };

  const COMPLETED_STEP_STATUSES = new Set(["submitted", "completed"]);

  const getStepEntry = (steps = [], stepNumber) =>
    steps.find((step) => Number(step.step) === Number(stepNumber));

  const getStepStatusValue = (steps = [], stepNumber) => {
    const entry = getStepEntry(steps, stepNumber);
    if (!entry) return "pending";
    if (COMPLETED_STEP_STATUSES.has(entry.status)) return "completed";
    if (entry.status === "in-progress") return "in-progress";
    return "pending";
  };

  const getHighestCompletedStepNumber = (steps = []) => {
    let highest = 0;
    steps.forEach((step) => {
      const stepNumber = Number(step.step);
      if (
        stepNumber >= 1 &&
        stepNumber <= 4 &&
        COMPLETED_STEP_STATUSES.has(step.status) &&
        stepNumber > highest
      ) {
        highest = stepNumber;
      }
    });
    return highest;
  };

  const hasAnyStepActivity = (steps = []) =>
    steps.some(
      (step) =>
        COMPLETED_STEP_STATUSES.has(step.status) || step.status === "in-progress"
    );

  const hasInProgressStatus = (steps = []) =>
    steps.some((step) => step.status === "in-progress");

  const matchesStepFilterForSteps = (steps = [], filterKey = "") => {
    const highestCompleted = getHighestCompletedStepNumber(steps);
    const hasProgress = hasAnyStepActivity(steps);
    const hasInProgress = hasInProgressStatus(steps);
    const statusFor = (stepNumber) => getStepStatusValue(steps, stepNumber);

    switch (filterKey) {
      case "total-in-progress":
        return hasInProgress;
      case "total-completed":
        return highestCompleted >= 4;
      case "total-pending":
        return !hasProgress;
      case "step1-in-progress":
        return statusFor(1) === "in-progress";
      case "step1-completed":
        return highestCompleted === 1;
      case "step1-pending":
        return statusFor(1) === "pending" && !hasProgress;
      case "step2-in-progress":
        return statusFor(2) === "in-progress";
      case "step2-completed":
        return highestCompleted === 2;
      case "step2-pending":
        return highestCompleted === 1 && statusFor(2) === "pending";
      case "step3-in-progress":
        return statusFor(3) === "in-progress";
      case "step3-completed":
        return highestCompleted === 3;
      case "step3-pending":
        return highestCompleted === 2 && statusFor(3) === "pending";
      case "step4-in-progress":
        return statusFor(4) === "in-progress";
      case "step4-completed":
        return highestCompleted >= 4;
      case "step4-pending":
        return highestCompleted === 3 && statusFor(4) === "pending";
      default: {
        const numericStep = parseInt(filterKey, 10);
        if (Number.isNaN(numericStep)) return false;
        return statusFor(numericStep) === "completed";
      }
    }
  };

  const flattenMemberSteps = (memberSteps = []) =>
    memberSteps.reduce((acc, stepsArray) => {
      if (Array.isArray(stepsArray)) {
        return acc.concat(stepsArray);
      }
      return acc;
    }, []);

  const userMatchesStepFilter = (user, filterKey) => {
    const stepData = userSteps[user._id];
    if (!stepData) return false;

    const primarySteps = stepData.steps || [];
    const memberSteps = stepData.memberSteps || [];

    if (filterKey.startsWith("total-")) {
      const combinedSteps = [...primarySteps, ...flattenMemberSteps(memberSteps)];
      return matchesStepFilterForSteps(combinedSteps, filterKey);
    }

    const entities = [primarySteps, ...memberSteps.filter((steps) => Array.isArray(steps))];

    return entities.some((steps) => matchesStepFilterForSteps(steps || [], filterKey));
  };

  const fetchUserSteps = async (userId) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/user/${userId}/steps`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!response.ok) throw new Error("Failed to fetch user steps");

      const data = await response.json();
      setUserSteps((prev) => ({
        ...prev,
        [userId]: {
          ...prev[userId],
          steps: data.steps
        }
      }));
    } catch (error) {
      setError(error.message);
    }
  };

  const fetchUserMemberSteps = async (userId, userObj = null) => {
    const token = localStorage.getItem("adminToken");
    try {
      const user = userObj || users.find(u => u._id === userId);
      if (!user || !user.members || user.members.length === 0) {
        setUserSteps((prev) => ({
          ...prev,
          [userId]: {
            ...prev[userId],
            memberSteps: []
          }
        }));
        return;
      }

      // Fetch all member steps in a single call (backend returns array of all members' steps)
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/user/${userId}/member-steps/0`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.ok) {
        const data = await response.json();
        // data.memberSteps is already an array where index = memberIndex
        setUserSteps((prev) => ({
          ...prev,
          [userId]: {
            ...prev[userId],
            memberSteps: data.memberSteps || []
          }
        }));
      } else {
        setUserSteps((prev) => ({
          ...prev,
          [userId]: {
            ...prev[userId],
            memberSteps: []
          }
        }));
      }
    } catch (error) {
      console.error('Error fetching member steps:', error);
      setUserSteps((prev) => ({
        ...prev,
        [userId]: {
          ...prev[userId],
          memberSteps: []
        }
      }));
    }
  };

  const filterUsers = () => {
    let filtered = users.filter(u => !u.isBookkeepingCollaborator);
    const taxStartDate = taxYearStart ? new Date(taxYearStart) : null;
    const taxEndDate = taxYearEnd ? new Date(taxYearEnd) : null;
    const dueStartDate = dueDateStart ? new Date(dueDateStart) : null;
    const dueEndDate = dueDateEnd ? new Date(dueDateEnd) : null;

    if (employeeFilter !== "all") {
      filtered = filtered.filter((user) => {
        const employee = employees.find((emp) =>
          emp.clients.some((client) => client._id === user._id)
        );
        return employee?._id === employeeFilter;
      });
    }

    if (stepFilter !== "all") {
      filtered = filtered.filter((user) => userMatchesStepFilter(user, stepFilter));
    }

    if (serviceFilter !== "all") {
      filtered = filtered.filter((user) => {
        switch (serviceFilter) {
          case "usa":
            return user.isUSAEnabled;
          case "tax":
            return user.isTaxFilingEnabled;
          case "bookkeeping":
            return user.isBookkeepingEnabled;
          case "cfo":
            return user.isCFOEnabled;
          case "registeredAgent":
            return user.isRegisteredAgentEnabled;
          default:
            return true;
        }
      });
    }

    if (paymentFilter !== "all") {
      filtered = filtered.filter((user) => {
        let hasPaid = false;
        let hasUnpaid = false;
        let hasWipUnpaid = false;
        let hasPExtension = false;
        let hasUPExtension = false;

        // Check primary services
        if (user.isUSAEnabled) hasPaid = true;
        if (user.isBookkeepingEnabled) hasPaid = true;
        if (user.isCFOEnabled) hasPaid = true;
        if (user.isRegisteredAgentEnabled) hasPaid = true;
        if (user.isAnnualReportServiceEnabled) hasPaid = true;

        if (user.isTaxFilingEnabled) {
          if (user.paymentStatus === 'wip-unpaid') hasWipUnpaid = true;
          else if (user.paymentStatus === 'p-extension') hasPExtension = true;
          else if (user.paymentStatus === 'up-extension') hasUPExtension = true;
          else if (user.taxFilingLocked) hasUnpaid = true;
          else hasPaid = true;
        }

        // Check members
        if (user.members && user.members.length > 0) {
          user.members.forEach((member) => {
            if (member.paymentStatus === 'wip-unpaid') hasWipUnpaid = true;
            else if (member.paymentStatus === 'p-extension') hasPExtension = true;
            else if (member.paymentStatus === 'up-extension') hasUPExtension = true;
            else if (member.taxFilingLocked) hasUnpaid = true;
            else hasPaid = true;
          });
        }

        if (paymentFilter === "paid") {
          return hasPaid;
        } else if (paymentFilter === "unpaid") {
          return hasUnpaid || (!hasPaid && !hasWipUnpaid && !hasPExtension && !hasUPExtension);
        } else if (paymentFilter === "wip-unpaid") {
          return hasWipUnpaid;
        } else if (paymentFilter === "p-extension") {
          return hasPExtension;
        } else if (paymentFilter === "up-extension") {
          return hasUPExtension;
        }

        return true;
      });
    }

    if (taxStartDate || taxEndDate) {
      filtered = filtered.filter((user) => {
        const primaryMatch = matchesDateRange(user.taxYearEndDate, taxStartDate, taxEndDate);
        const memberMatch = user.members?.some((member) =>
          matchesDateRange(member.taxYearEndDate, taxStartDate, taxEndDate)
        );
        return primaryMatch || memberMatch;
      });
    }

    if (dueStartDate || dueEndDate) {
      filtered = filtered.filter((user) => {
        const primaryMatch = matchesDateRange(user.dueDate, dueStartDate, dueEndDate);
        const memberMatch = user.members?.some((member) =>
          matchesDateRange(member.dueDate, dueStartDate, dueEndDate)
        );
        return primaryMatch || memberMatch;
      });
    }

    if (ratingFilter !== "all") {
      filtered = filtered.filter((user) => {
        const taxRating = user.feedback?.rating;
        const usaRating = user.usaFeedback?.rating;
        const bookRating = user.bookkeepingFeedback?.rating;
        const memberRatings = user.members?.map(m => m.feedback?.rating).filter(Boolean) || [];

        if (ratingFilter === 'missing') {
          // Show users who have missing feedback for primary services or any member
          const needsTaxFeedback = user.isTaxFilingEnabled && !taxRating;
          const needsUsaFeedback = user.isUSAEnabled && !usaRating;
          const needsBookkeepingFeedback = user.isBookkeepingEnabled && !bookRating;
          const membersNeedFeedback = user.isTaxFilingEnabled && user.members?.some(m => !m.feedback?.rating);
          return needsTaxFeedback || needsUsaFeedback || needsBookkeepingFeedback || membersNeedFeedback;
        }

        if (ratingFilter === 'provided') {
          // Show users who have provided feedback for any service or member
          return !!taxRating || !!usaRating || !!bookRating || memberRatings.length > 0;
        }
        
        const targetRating = parseInt(ratingFilter);
        const primaryMatch = taxRating === targetRating || usaRating === targetRating || bookRating === targetRating;
        const memberMatch = memberRatings.includes(targetRating);
        
        return primaryMatch || memberMatch;
      });
    }

    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((user) =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query) ||
        (user._id && user._id.toLowerCase().includes(query)) ||
        (user.members && user.members.some(m => m.name.toLowerCase().includes(query)))
      );
    }

    setFilteredUsers(filtered);
    setCurrentPage(1);
  };

  const getAssignedEmployee = (userId) => {
    const employee = employees.find((emp) =>
      emp.clients.some((client) => client._id === userId)
    );
    return employee ? employee.name : "-";
  };

  const handleExportExcel = () => {
    setShowExcelModal(true);
  };

  const isNewClient = (createdAt) => {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 3);
    return new Date(createdAt) > oneWeekAgo;
  };

  const indexOfLastClient = currentPage * clientsPerPage;
  const indexOfFirstClient = indexOfLastClient - clientsPerPage;
  const currentClients = filteredUsers.slice(indexOfFirstClient, indexOfLastClient);
  const totalPages = Math.ceil(filteredUsers.length / clientsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const toggleSelectOne = (userId) => {
    setSelectedIds((prev) => {
      const exists = prev.includes(userId);
      return exists ? prev.filter((id) => id !== userId) : [...prev, userId];
    });
  };

  const toggleSelectAll = () => {
    const allFilteredIds = filteredUsers.map((u) => u._id);
    const areAllSelected = allFilteredIds.length > 0 && allFilteredIds.every((id) => selectedIds.includes(id));

    if (areAllSelected) {
      setSelectedIds(selectedIds.filter((id) => !allFilteredIds.includes(id)));
    } else {
      const merged = Array.from(new Set([...selectedIds, ...allFilteredIds]));
      setSelectedIds(merged);
    }
  };

  const openEmailModal = () => setShowEmailModal(true);
  const closeEmailModal = () => setShowEmailModal(false);

  const sendBulkEmail = async () => {
    if (selectedIds.length === 0) {
      alert("Please select at least one client.");
      return;
    }
    if (!emailSubject.trim() || !emailBody.trim()) {
      alert("Subject and message are required.");
      return;
    }
    setSending(true);
    setSendProgress(0);

    try {
      const token = localStorage.getItem("adminToken");

      // Get user details first to show accurate progress
      const usersResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users-basic-info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ userIds: selectedIds })
      });

      if (!usersResponse.ok) {
        const errorData = await usersResponse.json();
        throw new Error(errorData.message || 'Failed to fetch user details');
      }

      const usersData = await usersResponse.json();
      const users = usersData.users || [];

      // Send emails one by one to track progress
      const results = [];
      for (let i = 0; i < users.length; i++) {
        const user = users[i];

        // Calculate and update progress
        const currentProgress = Math.round(((i) / users.length) * 100);
        setSendProgress(currentProgress);

        // Replace $name with user's name
        const personalizedHtml = emailBody.replace(/\$name/g, user.name || 'Client');

        // Send email to current user
        const emailResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/send-single-email`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            userId: user._id,
            subject: emailSubject,
            html: personalizedHtml
          })
        });

        const emailResult = await emailResponse.json();
        results.push({
          email: user.email,
          name: user.name,
          status: emailResponse.ok ? 'sent' : 'failed',
          error: !emailResponse.ok ? emailResult.message : undefined
        });
      }

      // Set progress to 100% when done
      setSendProgress(100);

      // Log the bulk email operation
      const logResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/log-bulk-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          userIds: selectedIds,
          subject: emailSubject,
          html: emailBody,
          results: results
        })
      });

      // Show success message
      const sentCount = results.filter(r => r.status === 'sent').length;
      setTimeout(() => {
        alert(`Emails sent: ${sentCount}/${results.length}`);
        setShowEmailModal(false);
        // Keep the email form data in case user wants to send similar email to others
        // But don't clear selectedIds so user can continue working with the same selection
        // setEmailSubject("");
        // setEmailBody("");
      }, 500); // Small delay to show 100% progress

    } catch (e) {
      alert(e.message);
    } finally {
      setTimeout(() => {
        setSending(false);
        setSendProgress(0);
      }, 1000); // Keep progress bar visible briefly
    }
  };

  const openHistory = async () => {
    setShowHistory(true);
    setHistoryLoading(true);
    setHistoryError("");
    try {
      const token = localStorage.getItem("adminToken");
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/email-logs?limit=50`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed to fetch email logs');
      setEmailLogs(data.items || []);
    } catch (e) {
      setHistoryError(e.message);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleDeleteEmailLog = async (logId) => {
    if (!window.confirm("Are you sure you want to delete this email log? It will be moved to the Recycle Bin.")) return;

    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/email-log/${logId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to delete email log");

      setEmailLogs(prev => prev.filter(log => log._id !== logId));
      alert("Email log moved to Recycle Bin");
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditFormData({ name: user.name, email: user.email });
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users/${selectedUser._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editFormData),
      });

      if (!response.ok) throw new Error("Failed to update user");

      const updatedUser = await response.json();
      setUsers(users.map((user) =>
        user._id === updatedUser.user._id ? updatedUser.user : user
      ));
      setShowEditModal(false);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDelete = (userId) => {
    const user = users.find(u => u._id === userId);
    if (user) {
      setUserToDelete(user);
      setDeleteConfirmationName("");
      setShowDeleteModal(true);
    }
  };

  const confirmDelete = async () => {
    if (!userToDelete || deleteConfirmationName !== userToDelete.name) {
      alert("UserName does not match. Please enter the correct name to delete.");
      return;
    }

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users/${userToDelete._id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to delete user");

      setUsers(users.filter((user) => user._id !== userToDelete._id));
      setFilteredUsers(filteredUsers.filter((user) => user._id !== userToDelete._id));
      setShowDeleteModal(false);
      setUserToDelete(null);
      setDeleteConfirmationName("");
      alert("User moved to Recycle Bin successfully.");
    } catch (error) {
      setError(error.message);
      alert("Failed to delete user: " + error.message);
    }
  };

  const handleImpersonateUser = async (userId, userName) => {
    if (!window.confirm(`Are you sure you want to login as ${userName}? This session will last 30 minutes.`)) {
      return;
    }

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/impersonation/impersonate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ userId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to impersonate user");
      }

      const data = await response.json();

      // Store admin session before impersonation
      const adminSession = {
        adminToken: token,
        adminID: localStorage.getItem("adminID"),
        impersonationLogId: data.impersonationLogId,
      };

      // Encode session data to pass via URL
      const sessionData = encodeURIComponent(JSON.stringify({
        token: data.token,
        userEmail: data.user.email,
        userName: data.user.name,
        adminSession: adminSession,
      }));

      // Redirect to user dashboard with session data in URL
      const userDashboardUrl = process.env.REACT_APP_USER_DASHBOARD_URL || "http://localhost:3001";
      window.location.href = `${userDashboardUrl}/login?impersonate=${sessionData}`;
    } catch (error) {
      console.error("Error impersonating user:", error);
      alert(`Failed to impersonate user: ${error.message}`);
    }
  };

  const toggleChatbox = (user) => {
    setChatUser(prev => (prev && prev._id === user._id) ? null : user);
  };

  const handleMenuClick = (user) => {
    setSelectedMenuUser(user);
    setSelectedStepUser(user);
    setActiveTab("services");
    setShowMenu(true);
  };

  const handleInvoiceClick = (user) => {
    setSelectedMenuUser(user);
    setSelectedStepUser(user);
    setActiveTab("documents");
    setShowMenu(true);
  };



  const handleAnnualReportClick = (user) => {
    navigate(`/client/${user._id}/annual-report`);
  }

  const handleFormAssignment = async (userId, formNumber) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/assign-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, formNumber }),
        }
      );

      if (!response.ok) throw new Error("Failed to assign form");

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
    } catch (error) {
      setError(error.message);
    }
  };

  const handleCompanyFormAssignment = async (userId, formNumber) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/assign-company-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, formNumber }),
        }
      );

      if (!response.ok) throw new Error("Failed to assign company form");

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
    } catch (error) {
      setError(error.message);
    }
  };

  const handleMemberFormAssignment = async (userId, memberIndex, formNumber) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/assign-member-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, memberIndex, formNumber }),
        }
      );

      if (!response.ok) throw new Error("Failed to assign member form");

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
    } catch (error) {
      setError(error.message);
    }
  };

  const handleTaxDateUpdate = async (userId, taxYearEndDate, dueDate, clearDates = false) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-tax-dates`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, taxYearEndDate, dueDate, clearDates }),
        }
      );

      if (!response.ok) throw new Error("Failed to update tax dates");

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser(data.user);
      }

      alert(clearDates ? "Tax dates removed successfully!" : "Tax dates updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update tax dates: " + error.message);
    }
  };

  const handleMemberTaxDateUpdate = async (userId, memberIndex, taxYearEndDate, dueDate, clearDates = false) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-member-tax-dates`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, memberIndex, taxYearEndDate, dueDate, clearDates }),
        }
      );

      if (!response.ok) throw new Error("Failed to update member tax dates");

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser(data.user);
      }

      alert(clearDates ? "Member tax dates removed successfully!" : "Member tax dates updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update member tax dates: " + error.message);
    }
  };

  const handleHistoryTaxDateUpdate = async (userId, memberIndex, historyIndex, taxYearEndDate, dueDate, clearDates = false) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-history-tax-dates`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, memberIndex, historyIndex, taxYearEndDate, dueDate, clearDates }),
        }
      );

      if (!response.ok) throw new Error("Failed to update history tax dates");

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser(data.user);
      }

      alert("History tax dates updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update history tax dates: " + error.message);
    }
  };

  const handleAnnualReportServiceUpdate = async (userId, state, entityType, registrationDate, yearsToAdd) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/annual-report/service/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ state, entityType, registrationDate, yearsToAdd }),
        }
      );

      if (!response.ok) throw new Error("Failed to update annual report service");

      const data = await response.json();

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? { ...user, annualReportService: data.annualReportService } : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({ ...selectedMenuUser, annualReportService: data.annualReportService });
      }

      alert("Annual Report Service due date updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update annual report service: " + error.message);
    }
  };

  const handleRemoveAnnualReportService = async (userId) => {
    if (!window.confirm("Are you sure you want to remove the Annual Report Service setup for this user?")) return;
    
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/annual-report/service/${userId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to remove annual report service");

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? { ...user, annualReportService: undefined } : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({ ...selectedMenuUser, annualReportService: undefined });
      }

      alert("Annual Report Service setup removed successfully!");
    } catch (error) {
      alert("Failed to remove annual report service: " + error.message);
    }
  };

  const handleBookkeepingServiceUpdate = async (userId, frequency, startDate) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/bookkeeping/service/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ frequency, startDate }),
        }
      );

      if (!response.ok) throw new Error("Failed to update bookkeeping service");

      const data = await response.json();

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? { ...user, bookkeepingService: data.bookkeepingService } : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({ ...selectedMenuUser, bookkeepingService: data.bookkeepingService });
      }

      alert("Bookkeeping Service due date updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update bookkeeping service: " + error.message);
    }
  };

  const handleRemoveBookkeepingService = async (userId) => {
    if (!window.confirm("Are you sure you want to remove the Bookkeeping Service setup for this user?")) return;
    
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/bookkeeping/service/${userId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to remove bookkeeping service");

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? { ...user, bookkeepingService: undefined } : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({ ...selectedMenuUser, bookkeepingService: undefined });
      }

      alert("Bookkeeping Service setup removed successfully!");
    } catch (error) {
      alert("Failed to remove bookkeeping service: " + error.message);
    }
  };

  const handleRegisteredAgentDueDateUpdate = async (userId, dueDate) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-registered-agent-due-date`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, dueDate }),
        }
      );

      if (!response.ok) throw new Error("Failed to update Registered Agent due date");

      const data = await response.json();

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? { ...user, registeredAgentService: data.user.registeredAgentService } : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({ ...selectedMenuUser, registeredAgentService: data.user.registeredAgentService });
      }

      alert("Registered Agent due date updated successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to update Registered Agent due date: " + error.message);
    }
  };

  const handleRegisteredAgentDocumentUpload = async (userId, files) => {
    if (!files || files.length === 0) return;
    const token = localStorage.getItem("adminToken");
    const formData = new FormData();
    formData.append("userId", userId);
    for (let i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/send-registered-agent-document`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Failed to upload Registered Agent document");

      const data = await response.json();

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? data.user : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser(data.user);
      }

      alert("Registered Agent document uploaded successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to upload Registered Agent document: " + error.message);
    }
  };

  const handleRegisteredAgentDocumentDelete = async (userId, documentId) => {
    if (!window.confirm("Are you sure you want to delete this document?")) return;
    
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/user/${userId}/registered-agent-document/${documentId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to delete Registered Agent document");

      const data = await response.json();

      // Update the user in the users list
      setUsers(users.map((user) =>
        user._id === userId ? data.user : user
      ));

      // Update selectedMenuUser if it's the same user
      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser(data.user);
      }

      alert("Registered Agent document deleted successfully!");
    } catch (error) {
      setError(error.message);
      alert("Failed to delete Registered Agent document: " + error.message);
    }
  };

  const handleStepSubmit = async () => {
    if (!selectedStepUser) {
      setError("No user selected for step submission");
      return;
    }

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/submit-step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedStepUser._id,
            step: selectedStep
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit step");
      }

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      await fetchUserSteps(selectedStepUser._id);
      setShowStepModal(false);
      alert(`Step ${selectedStep} submitted successfully!`);

      if (data.nextStep) {
        alert(`Step ${data.nextStep} has been unlocked for the client!`);
      }
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  const handleMemberStepSubmit = async (memberIndex) => {
    if (!selectedStepUser) {
      setError("No user selected for member step submission");
      return;
    }

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/submit-member-step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedStepUser._id,
            memberIndex,
            step: selectedStep
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit member step");
      }

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      await fetchUserMemberSteps(selectedStepUser._id);
      setShowStepModal(false);
      alert(`Member ${memberIndex + 1} Step ${selectedStep} submitted successfully!`);

      if (data.nextStep) {
        alert(`Member ${memberIndex + 1} Step ${data.nextStep} has been unlocked for the client!`);
      }
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  const isStepSubmitted = (user, step) => {
    if (!user || !userSteps[user._id]?.steps) return false;
    const stepInfo = userSteps[user._id].steps.find(s => s.step === step);
    return stepInfo && stepInfo.status === 'submitted';
  };

  const isMemberStepSubmitted = (user, memberIndex, step) => {
    if (!user || !userSteps[user._id]?.memberSteps?.[memberIndex]) return false;
    const stepInfo = userSteps[user._id].memberSteps[memberIndex].find(s => s.step === step);
    return stepInfo && stepInfo.status === 'submitted';
  };

  const canSubmitStep = (user, step) => {
    if (!user || !userSteps[user._id]?.steps) return false;
    if (step === 1) return true;

    for (let i = 1; i < step; i++) {
      const prevStep = userSteps[user._id].steps.find(s => s.step === i);
      if (!prevStep || prevStep.status !== 'submitted') {
        return false;
      }
    }
    return true;
  };

  const canSubmitMemberStep = (user, memberIndex, step) => {
    if (!user || !userSteps[user._id]?.memberSteps?.[memberIndex]) return false;
    if (step === 1) return true;

    for (let i = 1; i < step; i++) {
      const prevStep = userSteps[user._id].memberSteps[memberIndex].find(s => s.step === i);
      if (!prevStep || prevStep.status !== 'submitted') {
        return false;
      }
    }
    return true;
  };

  const handleAnnualReportStepStatusChange = async (userId, step, newStatus) => {
    const token = localStorage.getItem("adminToken");

    try {
      const user = users.find(u => u._id === userId);
      if (!user) throw new Error("User not found");

      let updatedSteps = [...(user.annualReportSteps || [])];

      if (updatedSteps.length === 0) {
        updatedSteps = [
          { step: 1, title: 'Checklist', status: 'pending' },
          { step: 2, title: 'Employee (Admin) side Handle', status: 'pending' }
        ];
      }

      const stepExists = updatedSteps.some(s => s.step === step);
      if (!stepExists) {
        updatedSteps.push({
          step,
          title: step === 1 ? 'Checklist' : 'Employee (Admin) side Handle',
          status: newStatus,
        });
      }

      const step1Submitted = updatedSteps.find((s) => s.step === 1)?.status === 'submitted';
      let resolvedStatus = newStatus;
      if (step === 2 && step1Submitted && newStatus === 'pending') {
        resolvedStatus = 'in-progress';
      }

      updatedSteps = updatedSteps.map(s => {
        if (s.step === step) {
          const updated = { ...s, status: resolvedStatus };
          if (resolvedStatus === 'submitted') {
            updated.completedAt = new Date();
          } else {
            delete updated.completedAt;
          }
          return updated;
        }
        return s;
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/annual-report/steps/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ steps: updatedSteps }),
        }
      );

      if (!response.ok) throw new Error("Failed to update annual report steps");

      const data = await response.json();

      const applyAnnualReportUpdate = (u) =>
        u._id === userId
          ? {
              ...u,
              annualReportSteps: data.annualReportSteps,
              ...(data.annualReportService ? { annualReportService: data.annualReportService } : {}),
              ...(data.annualReportHistory ? { annualReportHistory: data.annualReportHistory } : {}),
              ...(typeof data.annualReportLocked === 'boolean' ? { annualReportLocked: data.annualReportLocked } : {}),
            }
          : u;

      setUsers((prev) => prev.map(applyAnnualReportUpdate));
      setFilteredUsers((prev) => prev.map(applyAnnualReportUpdate));

      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({
          ...selectedMenuUser,
          annualReportSteps: data.annualReportSteps,
          ...(data.annualReportService ? { annualReportService: data.annualReportService } : {}),
          ...(data.annualReportHistory ? { annualReportHistory: data.annualReportHistory } : {}),
          ...(typeof data.annualReportLocked === 'boolean' ? { annualReportLocked: data.annualReportLocked } : {}),
        });
      }

      if (data.dueDateAdvanced) {
        alert(data.message || `Due date advanced to ${data.dueDateAdvanced.dueDateText}`);
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const handleReopenAnnualReportChecklist = async (userId) => {
    const token = localStorage.getItem("adminToken");
    if (!window.confirm("Are you sure you want to re-open the checklist for this user? This will allow them to edit and submit again.")) return;

    try {
      const user = users.find(u => u._id === userId);
      if (!user) throw new Error("User not found");

      let updatedSteps = [...(user.annualReportSteps || [])].map(s => {
        if (s.step === 1) {
          return { ...s, status: 'in-progress' };
        }
        return s;
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/annual-report/steps/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ steps: updatedSteps }),
        }
      );

      if (!response.ok) throw new Error("Failed to re-open checklist");

      const data = await response.json();
      
      setUsers(users.map((u) =>
        u._id === userId
          ? {
              ...u,
              annualReportSteps: data.annualReportSteps,
            }
          : u
      ));

      if (selectedMenuUser?._id === userId) {
        setSelectedMenuUser({
          ...selectedMenuUser,
          annualReportSteps: data.annualReportSteps,
        });
      }

      alert(`Checklist re-opened successfully for the user!`);
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  const areAllStepsCompleted = (userId) => {
    if (!userSteps[userId]?.steps) return false;

    const steps = userSteps[userId].steps;

    // Check if user completed all 5 steps in the old system
    const completedAllOldSteps = steps.length >= 5 &&
      steps.every(step => step.status === 'submitted' || step.status === 'completed');

    if (completedAllOldSteps) return true;

    // Check for 4 completed steps in the new system
    const relevantSteps = steps.filter(step => step.step <= 4);
    const completedSteps = relevantSteps.filter(
      step => step.status === 'submitted' || step.status === 'completed'
    ).length;

    return completedSteps >= 4; // Using >= to handle any future cases
  };

  const isUSAFormationCompleted = (user) => {
    if (!user || !user.companySteps || user.companySteps.length === 0) return false;
    const completedSteps = user.companySteps.filter(step => step.status === 'submitted').length;
    const totalSteps = user.companySteps.length;
    return totalSteps > 0 && completedSteps === totalSteps;
  };

  const areAllMemberStepsCompleted = (userId, memberIndex) => {
    if (!userSteps[userId]?.memberSteps?.[memberIndex]) return false;

    const steps = userSteps[userId].memberSteps[memberIndex];

    // Check if member completed all 5 steps in the old system
    const completedAllOldSteps = steps.length >= 5 &&
      steps.every(step => step.status === 'submitted' || step.status === 'completed');

    if (completedAllOldSteps) return true;

    // Check for 4 completed steps in the new system
    const relevantSteps = steps.filter(step => step.step <= 4);
    const completedSteps = relevantSteps.filter(
      step => step.status === 'submitted' || step.status === 'completed'
    ).length;

    return completedSteps >= 4; // Using >= to handle any future cases
  };

  const renderStepsProgress = (userId, memberIndex = null) => {
    if (!userSteps[userId]) return null;

    // For primary user steps
    if (memberIndex === null) {
      const user = users.find(u => u._id === userId);
      if (user && user.taxFilingLocked) {
        return <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 rounded-full">Locked</span>;
      }

      if (areAllStepsCompleted(userId)) {
        return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">Completed</span>;
      }

      const steps = userSteps[userId]?.steps || [];
      const activeSteps = steps.filter(step => step.status === "in-progress" || step.status === "client-pending");

      if (activeSteps.length === 0) {
        // If there are no in-progress or client-pending steps, check if ALL steps are finished
        if (steps.every(s => s.status === 'pending' || s.status === 'submitted')) {
          // If none are active, and not all are completed, but some are submitted, just show Not Started or maybe something else?
          // Actually, if we reach here, it's not completed. So let's find the max step submitted.
          const submittedSteps = steps.filter(s => s.status === 'submitted');
          if (submittedSteps.length > 0) {
            return <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 rounded-full">In Progress</span>;
          }
        }
        return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
      }

      return activeSteps.map((step) => {
        const formattedStatus = step.status.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
        const statusColors = {
          'in-progress': 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
          'client-pending': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400'
        };
        const colorClass = statusColors[step.status] || 'bg-gray-100 text-gray-700';

        return (
          <span key={`primary-${step.step}`} className={`px-2 py-1 text-xs font-medium ${colorClass} rounded-full mr-1`}>
            Step {step.step}: {formattedStatus}
          </span>
        );
      });
    }

    // For member steps
    if (userSteps[userId]?.memberSteps?.[memberIndex]) {
      const user = users.find(u => u._id === userId);
      const member = user?.members?.[memberIndex];
      if (member && member.taxFilingLocked) {
        return <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 rounded-full">Locked</span>;
      }

      if (areAllMemberStepsCompleted(userId, memberIndex)) {
        return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">Completed</span>;
      }

      const steps = userSteps[userId].memberSteps[memberIndex];
      const activeSteps = steps.filter(step => step.status === "in-progress" || step.status === "client-pending");

      if (activeSteps.length === 0) {
        const submittedSteps = steps.filter(s => s.status === 'submitted');
        if (submittedSteps.length > 0) {
          return <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 rounded-full">In Progress</span>;
        }
        return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
      }

      return activeSteps.map((step) => {
        const formattedStatus = step.status.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
        const statusColors = {
          'in-progress': 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
          'client-pending': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400'
        };
        const colorClass = statusColors[step.status] || 'bg-gray-100 text-gray-700';

        return (
          <span key={`member-${memberIndex}-${step.step}`} className={`px-2 py-1 text-xs font-medium ${colorClass} rounded-full mr-1`}>
            Step {step.step}: {formattedStatus}
          </span>
        );
      });
    }

    return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
  };

  const renderUSAFormationStepsProgress = (userId) => {
    const user = users.find(u => u._id === userId);
    if (!user || !user.companySteps || user.companySteps.length === 0) {
      return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
    }

    const completedSteps = user.companySteps.filter(step => step.status === 'submitted').length;
    const totalSteps = user.companySteps.length;

    if (totalSteps > 0 && completedSteps === totalSteps) {
      return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">Completed</span>;
    }

    const inProgressSteps = user.companySteps.filter(step => step.status === "in-progress");

    if (inProgressSteps.length === 0) {
      return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
    }

    return inProgressSteps.map((step) => (
      <span key={`usa-formation-${step.step}`} className="px-2 py-1 text-xs font-medium bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 rounded-full mr-1">
        Step {step.step}: {step.status}
      </span>
    ));
  };

  const renderBookkeepingStepsProgress = (userId) => {
    const user = users.find(u => u._id === userId);
    if (!user || !user.bookkeepingSteps || user.bookkeepingSteps.length === 0) {
      return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
    }

    const completedSteps = user.bookkeepingSteps.filter(step => step.status === 'completed').length;
    const totalSteps = user.bookkeepingSteps.length;

    if (totalSteps > 0 && completedSteps === totalSteps) {
      return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">Completed</span>;
    }

    const activeSteps = user.bookkeepingSteps.filter(step => step.status === "in-progress" || step.status === "client-pending");

    if (activeSteps.length === 0) {
      const submittedSteps = user.bookkeepingSteps.filter(s => s.status === 'submitted');
      if (submittedSteps.length > 0) {
        return <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 rounded-full">In Progress</span>;
      }
      return <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full">Not Started</span>;
    }

    return activeSteps.map((step) => {
      const formattedStatus = step.status.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
      const statusColors = {
        'in-progress': 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
        'client-pending': 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
        'submitted': 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
      };
      const colorClass = statusColors[step.status] || 'bg-gray-100 text-gray-700';

      return (
        <span key={`bookkeeping-${step.step}`} className={`px-2 py-1 text-xs font-medium ${colorClass} rounded-full mr-1`}>
          Step {step.step}: {formattedStatus}
        </span>
      );
    });
  };

  const handleMemberNameUpdate = async (userId, memberIndex, name) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-member-name`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, memberIndex, name }),
        }
      );

      if (!response.ok) throw new Error("Failed to update member name");

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }
      return data;
    } catch (error) {
      setError(error.message);
    }
  };

  const toggleMemberSection = async (userId, isEnabled) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/toggle-member-section`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, isEnabled }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to toggle member section");
      }

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const addMember = async (userId, memberName = "") => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/add-member`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, name: memberName }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add member");
      }

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }
      return data;
    } catch (error) {
      setError(error.message);
      throw error;
    }
  };

  const handleMemberDelete = (userId, memberIndex) => {
    const user = users.find(u => u._id === userId);
    if (!user || !user.members || !user.members[memberIndex]) return;

    setMemberToDelete({ userId, index: memberIndex, name: user.members[memberIndex].name || `Member ${memberIndex + 1}` });
    setMemberDeleteConfirmationName("");
    setShowMemberDeleteModal(true);
  };

  const confirmMemberDelete = async () => {
    if (!memberToDelete || memberDeleteConfirmationName !== memberToDelete.name) return;

    try {
      await removeMember(memberToDelete.userId, memberToDelete.index);
      setShowMemberDeleteModal(false);
      setMemberToDelete(null);
      setMemberDeleteConfirmationName("");
    } catch (error) {
      console.error("Error deleting member:", error);
      alert("Failed to delete member: " + error.message);
    }
  };

  const removeMember = async (userId, memberIndex) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/remove-member`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, memberIndex }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to remove member");
      }

      const data = await response.json();
      setUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      setFilteredUsers(prev => prev.map((user) =>
        user._id === data.user._id ? data.user : user
      ));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }
      return data;
    } catch (error) {
      console.error("Error removing member:", error);
      setError(error.message);
      throw error;
    }
  };

  const toggleServiceLock = async (userId, serviceName, isEnabled) => {
    const token = localStorage.getItem("adminToken");
    const toggleKey = `${userId}-${serviceName}`;

    // Prevent multiple simultaneous toggles
    if (toggleLoading[toggleKey]) {
      return;
    }

    // Set loading state for this specific toggle
    setToggleLoading(prev => ({ ...prev, [toggleKey]: true }));

    // Auto-clear loading state after 500ms for instant UI response
    const loadingTimeout = setTimeout(() => {
      setToggleLoading(prev => ({ ...prev, [toggleKey]: false }));
    }, 500);

    // Optimistic update - update UI immediately
    const updateField = {
      'USA Company Formation': 'isUSAEnabled',
      'Tax Filing': 'isTaxFilingEnabled',
      'Bookkeeping': 'isBookkeepingEnabled',
      'CFO Advisory': 'isCFOEnabled',
      'Registered Agent': 'isRegisteredAgentEnabled',
      'Annual Report Service': 'isAnnualReportServiceEnabled'
    }[serviceName];

    // Update local state immediately for instant feedback
    const updatedUser = { ...selectedMenuUser, [updateField]: isEnabled };
    setSelectedMenuUser(updatedUser);
    setUsers(users.map((user) =>
      user._id === userId ? updatedUser : user
    ));

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/toggle-service`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ userId, serviceName, isEnabled }),
      });

      if (!response.ok) {
        throw new Error("Failed to toggle service");
      }

      // Success - optimistic update was correct
      console.log(`Service ${serviceName} ${isEnabled ? 'enabled' : 'disabled'} successfully`);

    } catch (error) {
      console.error("Service toggle error:", error);

      // Revert optimistic update on error
      const revertedUser = { ...selectedMenuUser, [updateField]: !isEnabled };
      setSelectedMenuUser(revertedUser);
      setUsers(users.map((user) =>
        user._id === userId ? revertedUser : user
      ));

      // Show brief error message
      setError(`Failed to ${isEnabled ? 'enable' : 'disable'} ${serviceName}`);
      setTimeout(() => setError(""), 3000);
    } finally {
      // Clear loading state and timeout
      clearTimeout(loadingTimeout);
      setToggleLoading(prev => ({ ...prev, [toggleKey]: false }));
    }
  };

  const handleUSAFormationStepSubmit = async (stepNumber) => {
    if (!selectedStepUser) {
      setError("No user selected for USA Formation step submission");
      return;
    }

    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/usa-company-formation/admin/submit-step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedStepUser._id,
            step: stepNumber
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit USA Formation step");
      }

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      alert(`USA Formation Step ${stepNumber} submitted successfully!`);

      if (data.nextStep) {
        alert(`Step ${data.nextStep} has been unlocked for the client!`);
      }
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  const isUSAFormationStepSubmitted = (userId, stepNumber) => {
    const user = users.find(u => u._id === userId);
    if (!user || !user.companySteps) return false;

    const step = user.companySteps.find(s => s.step === stepNumber);
    return step && step.status === 'submitted';
  };

  const canSubmitUSAFormationStep = (userId, stepNumber) => {
    const user = users.find(u => u._id === userId);
    if (!user || !user.companySteps) return false;

    // Step 1 can only be submitted by user
    if (stepNumber === 1) return false;

    // For steps 2 and 3, check if previous step is submitted
    if (stepNumber > 1) {
      const previousStep = user.companySteps.find(s => s.step === stepNumber - 1);
      if (!previousStep || previousStep.status !== 'submitted') return false;
    }

    const currentStep = user.companySteps.find(s => s.step === stepNumber);
    return currentStep && currentStep.status !== 'submitted';
  };

  const handleQuickPayment = (user) => {
    setSelectedUserForPayment(user._id);
    setShowQuickPaymentModal(true);
  };

  const updateQuickPayment = (data) => {
    setQuickPaymentData(data);
  };

  // Move completed tax filing to history and lock new cycle
  const handleMoveToHistory = async (userId, memberIndex, newTaxYearEndDate, newDueDate) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/move-to-history`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          memberIndex,
          newTaxYearEndDate,
          newDueDate
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to move to history");
      }

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      // Update selected menu user if it's the same user
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }

      alert("Tax filing moved to history and new cycle locked successfully!");
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  // Unlock tax filing (admin override)
  const handleUnlockTaxFiling = async (userId, memberIndex) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/unlock-tax-filing`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          memberIndex,
          paymentId: 'admin_override'
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to unlock tax filing");
      }

      const data = await response.json();
      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      // Update selected menu user if it's the same user
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }

      alert("Tax filing unlocked successfully!");
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  const handleUnlockAnnualReport = async (userId) => {
    return handleAnnualReportPaymentStatusUpdate(userId, 'paid');
  };

  const handleAnnualReportPaymentStatusUpdate = async (userId, paymentStatus) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/update-annual-report-payment-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          paymentStatus,
          paymentId: paymentStatus === 'paid' ? 'admin_override' : undefined,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update annual report payment status");
      }

      const data = await response.json();
      setUsers((prev) => prev.map((user) => (user._id === data.user._id ? data.user : user)));
      setFilteredUsers((prev) => prev.map((user) => (user._id === data.user._id ? data.user : user)));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }
      alert(data.message || "Annual Report payment status updated!");
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  // Update tax filing unlock price (USD)
  const handleUpdateTaxFilingUnlockPrice = async (userId, memberIndex, priceUsd) => {
    const token = localStorage.getItem("adminToken");
    try {
      const cents = Math.round(Number(priceUsd) * 100);
      if (!Number.isFinite(cents) || cents < 100) {
        throw new Error("Price must be at least $1");
      }

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/tax-filing-unlock-price`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          memberIndex: memberIndex === undefined ? null : memberIndex,
          priceCents: cents
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update tax filing unlock price");
      }

      const data = await response.json();
      setUsers(users.map((user) => (user._id === data.user._id ? data.user : user)));
      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }

      alert("Tax filing unlock price updated successfully!");
    } catch (error) {
      setError(error.message);
      alert(error.message);
    }
  };

  // Create/update admin-configured Tax Filing summary table (primary or member)
  const handleUpdateTaxSummaryTable = async (userId, memberIndex, table) => {
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/tax-summary-table`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId,
          // For primary we send null, for members we send numeric index
          memberIndex: memberIndex === undefined ? null : memberIndex,
          table
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.message || "Failed to update Tax Filing table");
      }

      setUsers(users.map((user) =>
        user._id === data.user._id ? data.user : user
      ));

      if (selectedMenuUser && selectedMenuUser._id === data.user._id) {
        setSelectedMenuUser(data.user);
      }

      alert("Tax Filing table saved successfully!");
    } catch (error) {
      console.error("Error updating tax summary table:", error);
      setError(error.message);
      alert(error.message);
    }
  };

  const handleDownloadReport = async () => {
    const token = localStorage.getItem("adminToken");
    try {
      let apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/auth/download-users-report`;
      if (selectedIds.length > 0) {
        apiUrl += `?userIds=${selectedIds.join(",")}`;
      }

      const response = await fetch(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Failed to download report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'All_Users_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();

    } catch (error) {
      setError(error.message);
      alert('Failed to download report: ' + error.message);
    }
  };

  const handlePreviewChecklist = (user, memberIndex = -1, mode = 'preview', serviceType = 'tax') => {
    if (!user) {
      alert('Error: User data is missing');
      return;
    }

    let formType;
    if (serviceType === 'bookkeeping') {
      formType = 'Bookkeeping';
    } else {
      formType = memberIndex === -1
        ? user.assignedForm
        : (user.members && user.members[memberIndex] ? user.members[memberIndex].assignedForm : null);
    }

    if (!formType) {
      alert('No form assigned. Cannot preview checklist.');
      return;
    }

    setChecklistUser(user);
    setChecklistMemberIndex(memberIndex);
    setChecklistFormType(formType);
    setChecklistMode(mode);
    setShowChecklistModal(true);
  };

  const handleReviewChecklist = (user, memberIndex = -1, serviceType = 'tax') => {
    if (!user) {
      alert('Error: User data is missing');
      return;
    }

    let formType;
    if (serviceType === 'bookkeeping') {
      formType = 'Bookkeeping';
    } else {
      formType = memberIndex === -1
        ? user.assignedForm
        : (user.members && user.members[memberIndex] ? user.members[memberIndex].assignedForm : null);
    }

    if (!formType) {
      alert('No form assigned. Cannot review checklist.');
      return;
    }

    setChecklistUser(user);
    setChecklistMemberIndex(memberIndex);
    setChecklistFormType(formType);
    setChecklistMode('review');
    setShowChecklistModal(true);
  };

  const handleOpenStep1Checklist = (user, memberIndex = -1) => {
    if (!user) {
      alert('Error: User data is missing');
      return;
    }
    setStep1ChecklistUser(user);
    setStep1ChecklistMemberIndex(memberIndex);
    setShowStep1ChecklistModal(true);
  };

  // Step 3 Management Functions
  const handleOpenStep3CustomTable = async (user, memberIndex, options = {}) => {
    const { isEdit = false } = options;
    setStep3User(user);
    setStep3MemberIndex(memberIndex);

    const currentStatus = getStep3Status(user._id, memberIndex);
    setStep3IsEditMode(isEdit || currentStatus === 'client-pending');

    // Fetch existing table if any
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/step3-custom-table?userId=${user._id}&memberIndex=${memberIndex >= 0 ? memberIndex : ''}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStep3CustomTable(data.customTable);
      } else {
        setStep3CustomTable(null);
      }
    } catch (error) {
      console.error('Error fetching Step 3 custom table:', error);
      setStep3CustomTable(null);
    }

    setShowStep3CustomTableModal(true);
  };

  const handleEditStep3Table = async () => {
    if (!step3User) return;
    const hasClientSubmission = step3CustomTable?.userSubmittedData?.length > 0;
    if (hasClientSubmission) {
      if (!window.confirm('Editing will clear the client\'s submitted remarks and reset Step 3 to Client Pending. Continue?')) {
        return;
      }
    }
    setShowStep3SubmittedDataModal(false);
    setStep3IsEditMode(true);
    setShowStep3CustomTableModal(true);
  };

  const syncSelectedMenuUser = (userId, usersList) => {
    if (!userId || selectedMenuUser?._id !== userId) return;
    const refreshed = usersList.find((u) => u._id === userId);
    if (refreshed) setSelectedMenuUser(refreshed);
  };

  const handleSaveStep3CustomTable = async (customTable) => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-step3-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: step3User._id,
            memberIndex: step3MemberIndex >= 0 ? step3MemberIndex : null,
            status: 'client-pending',
            customTable,
            isTableUpdate: step3IsEditMode
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to save custom table");
      }

      await response.json();

      const usersResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (usersResponse.ok) {
        const data = await usersResponse.json();
        const sortedUsers = sortUsersList(data);
        setUsers(sortedUsers);
        setFilteredUsers(sortedUsers);
        syncSelectedMenuUser(step3User._id, sortedUsers);
      } else {
        await fetchUsers();
      }

      await fetchUserSteps(step3User._id);

      const wasEdit = step3IsEditMode;
      setShowStep3CustomTableModal(false);
      setStep3IsEditMode(false);
      alert(wasEdit
        ? 'Step 3 table updated and sent to client successfully!'
        : 'Step 3 table submitted to client successfully!');
    } catch (error) {
      console.error('Error saving Step 3 custom table:', error);
      alert('Failed to save custom table: ' + error.message);
    }
  };

  const handleViewStep3Submission = async (user, memberIndex) => {
    setStep3User(user);
    setStep3MemberIndex(memberIndex);

    // Fetch submitted data
    const token = localStorage.getItem("adminToken");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/step3-custom-table?userId=${user._id}&memberIndex=${memberIndex >= 0 ? memberIndex : ''}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStep3CustomTable(data.customTable);
        setShowStep3SubmittedDataModal(true);
      } else {
        alert('Failed to fetch Step 3 submission data');
      }
    } catch (error) {
      console.error('Error fetching Step 3 submission:', error);
      alert('Error fetching submission data');
    }
  };

  const handleMarkStep3Completed = async () => {
    const token = localStorage.getItem("adminToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/update-step3-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: step3User._id,
            memberIndex: step3MemberIndex >= 0 ? step3MemberIndex : null,
            status: 'submitted'
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to mark Step 3 as completed");
      }

      // Update users list
      await fetchUsers();
      await fetchUserSteps(step3User._id);

      setShowStep3SubmittedDataModal(false);
      alert('Step 3 marked as Completed successfully!');
    } catch (error) {
      console.error('Error marking Step 3 as completed:', error);
      alert('Failed to mark Step 3 as completed: ' + error.message);
    }
  };

  const getStep3Status = (userId, memberIndex) => {
    if (!userSteps[userId]) return null;

    const steps = memberIndex >= 0
      ? userSteps[userId]?.memberSteps?.[memberIndex]
      : userSteps[userId]?.steps;

    if (!steps) return null;

    const step3 = steps.find(s => s.step === 3);
    return step3?.status || null;
  };

  const [openDropdown, setOpenDropdown] = useState(null);
  const [dropdownUser, setDropdownUser] = useState(null);

  const handleRowClick = (user, serviceKey = 'services', e, memberIndex = -1) => {
    if (e.target.closest('button, input, select, a, [role="button"]')) return;
    const tabMap = {
      isUSAEnabled: 'usa-formation',
      isTaxFilingEnabled: 'primary',
      isBookkeepingEnabled: 'bookkeeping',
      isCFOEnabled: 'services',
      isRegisteredAgentEnabled: 'registered-agent',
      isAnnualReportServiceEnabled: 'annual-report',
      member: 'primary'
    };
    setSelectedMenuUser(user);
    setActiveTab(tabMap[serviceKey] || serviceKey || 'services');
    setMenuInitialMemberIndex(memberIndex);
    setShowMenu(true);
  };

  const renderClientRows = () => {
    return currentClients.map((user, index) => {
      const absoluteIndex = indexOfFirstClient + index;

      return (
        <React.Fragment key={user._id}>
          {/* Primary client row */}
          <tr 
            onClick={(e) => handleRowClick(user, 'services', e)}
            className={`
            group bg-white dark:bg-dark-800 border-b border-gray-100 dark:border-dark-700 
            transition-all duration-200 hover:bg-primary-50/50 dark:hover:bg-primary-900/20 cursor-pointer
            ${index > 0 ? 'border-t-2 border-gray-200/60 dark:border-dark-600' : ''}
          `}>

            {selectionMode && (
              <td className="px-4 py-3 w-12">
                <input type="checkbox" checked={selectedIds.includes(user._id)} onChange={() => toggleSelectOne(user._id)} className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
              </td>
            )}
            <td className="pl-4 pr-1 py-3 text-sm text-gray-600 dark:text-gray-400 w-12">{absoluteIndex + 1}</td>

            <td 
              onClick={(e) => {
                e.stopPropagation();
                handleRowClick(user, 'profile', e);
              }}
              className="px-4 py-3 min-w-[250px] cursor-pointer group-hover:text-primary-600 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div className="relative flex-shrink-0">
                  {user.profilePicture ? (
                    <img
                      src={user.profilePicture}
                      alt={user.name}
                      className="w-10 h-10 rounded-full object-cover border-2 border-primary-100"
                      onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=random&color=fff`; }}
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-lg">
                      {user.name.charAt(0).toUpperCase()}
                    </div>
                  )}
                  {onlineUserIds.includes(user._id) && (
                    <span
                      className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-white dark:border-dark-800 rounded-full animate-pulse"
                      title="Online Now"
                    />
                  )}
                </div>
                <div className="flex flex-col">
                  <span className="font-medium text-gray-900 dark:text-white flex items-center gap-2">
                    {user.name}
                    {onlineUserIds.includes(user._id) && (
                      <span className="flex items-center gap-1 text-[10px] font-extrabold uppercase text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/30 px-2 py-0.5 rounded-full border border-emerald-200/50 dark:border-emerald-800/50">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" />
                        Active
                      </span>
                    )}
                    {isNewClient(user.createdAt) && <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 rounded-full">New</span>}
                    {!user.isVerified && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggleVerify(user._id);
                        }}
                        className="px-2 py-0.5 text-[10px] font-bold rounded-full transition-all cursor-pointer select-none bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 hover:bg-red-200"
                        title="Blocked / Unverified User (Click to Unblock / Verify)"
                      >
                        Blocked
                      </button>
                    )}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTogglePin(user._id);
                      }}
                      className={`focus:outline-none transition-all duration-200 ml-1 hover:scale-110 ${
                        user.isPinned 
                          ? "text-primary-500 dark:text-primary-400 drop-shadow-sm opacity-100" 
                          : "text-gray-300 dark:text-gray-600 hover:text-gray-400 opacity-0 group-hover:opacity-100"
                      }`}
                      title={user.isPinned ? "Unpin Client" : "Pin Client"}
                    >
                      <FaThumbtack className={`w-3.5 h-3.5 transition-transform ${user.isPinned ? "" : "-rotate-45"}`} />
                    </button>
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400">{user.email}</span>
                </div>
              </div>
            </td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[100px] text-center">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[120px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[150px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[100px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[150px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[150px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[100px]">-</td>
            <td className="px-4 py-3 text-sm text-gray-500 min-w-[100px]">-</td>
            <td className="px-4 py-3 min-w-[120px] sticky right-0 bg-white dark:bg-dark-800">
              <div className="inline-flex items-center rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 overflow-hidden shadow-sm">
                {/* Chatbox Icon Button */}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleChatbox(user);
                  }}
                  className="px-3 py-2 text-primary-600 dark:text-primary-400 hover:bg-gray-100 dark:hover:bg-dark-600 transition-all border-r border-gray-200 dark:border-dark-600 cursor-pointer"
                  title="Open Chat"
                >
                  <img src="/chat-icon.png" className="w-4 h-4 object-contain" alt="Chat" />
                </button>

                {/* 3 Dots Actions Button */}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdown(openDropdown === user._id ? null : user._id);
                    setDropdownUser(user);
                  }}
                  className="px-3 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-600 transition-all cursor-pointer"
                  title="More Actions"
                >
                  <FaEllipsisV className="w-3.5 h-3.5" />
                </button>
              </div>
            </td>
          </tr>

          {/* Service rows */}
          {[
            { key: 'isUSAEnabled', name: 'USA Company' },
            { key: 'isTaxFilingEnabled', name: 'Tax Filing' },
            { key: 'isBookkeepingEnabled', name: 'Bookkeeping' },
            { key: 'isCFOEnabled', name: 'CFO Advisory' },
            { key: 'isRegisteredAgentEnabled', name: 'Registered Agent' },
            { key: 'isAnnualReportServiceEnabled', name: 'Annual Report Service' }
          ].map(service => (
            user[service.key] && (
              <tr 
                key={`${user._id}-${service.key}`} 
                onClick={(e) => handleRowClick(user, service.key, e)}
                className="bg-gray-50/50 dark:bg-dark-700/30 border-b border-gray-100 dark:border-dark-700 transition-colors hover:bg-primary-50/40 dark:hover:bg-primary-900/20 cursor-pointer"
              >

                {selectionMode && <td className="px-4 py-3 w-12"></td>}
                <td className="pl-4 pr-1 py-3 w-12"></td>

                <td className="px-4 py-3 min-w-[250px]">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300 pl-4 border-l-2 border-primary-400 dark:border-primary-500">
                    {user.name} - {service.name}
                  </span>
                </td>
                <td className="px-4 py-3 w-20">
                  {service.key === 'isTaxFilingEnabled' ? (
                    user.paymentStatus === 'wip-unpaid' ? (
                      <span className="px-2 py-1 text-[10px] font-bold bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full whitespace-nowrap">WIP-Unpaid</span>
                    ) : user.paymentStatus === 'p-extension' ? (
                      <span className="px-2 py-1 text-[10px] font-bold bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400 rounded-full whitespace-nowrap">P Extension</span>
                    ) : user.paymentStatus === 'up-extension' ? (
                      <span className="px-2 py-1 text-[10px] font-bold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400 rounded-full whitespace-nowrap">UP Extension</span>
                    ) : user.taxFilingLocked ? (
                      <span className="px-2 py-1 text-[10px] font-bold bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 rounded-full whitespace-nowrap">Unpaid</span>
                    ) : (
                      <span className="px-2 py-1 text-[10px] font-bold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full whitespace-nowrap">Paid</span>
                    )
                  ) : (
                    <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full">Paid</span>
                  )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 min-w-[120px]">{getAssignedEmployee(user._id)}</td>
                <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 min-w-[150px]">{service.name}</td>
                <td className="px-4 py-3 min-w-[100px]">
                  {service.key === 'isTaxFilingEnabled' && user.assignedForm ? (
                    <span className="px-2 py-1 text-xs font-medium bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 rounded-full">{user.assignedForm}</span>
                  ) : <span className="text-sm text-gray-400">No</span>}
                </td>
                <td className="px-4 py-3 min-w-[150px]">
                  {service.key === 'isUSAEnabled' ? (
                    user.usaFeedback?.rating ? (
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => <FaStar key={i} className={`${i < user.usaFeedback.rating ? "text-yellow-400" : "text-gray-300"} w-3.5 h-3.5`} />)}
                        {user.usaFeedback.comment && <FaComment className="ml-2 text-gray-400 cursor-pointer w-3.5 h-3.5" title="View Comment" onClick={() => setFeedbackViewData({ isOpen: true, title: "USA Formation Feedback", content: user.usaFeedback.comment })} />}
                      </div>
                    ) : <span className="text-sm text-gray-400">No rating</span>
                  ) : service.key === 'isTaxFilingEnabled' ? (
                    areAllStepsCompleted(user._id) && user.feedback?.rating ? (
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => <FaStar key={i} className={`${i < user.feedback.rating ? "text-yellow-400" : "text-gray-300"} w-3.5 h-3.5`} />)}
                        {user.feedback.comment && <FaComment className="ml-2 text-gray-400 cursor-pointer w-3.5 h-3.5" title="View Comment" onClick={() => setFeedbackViewData({ isOpen: true, title: "Tax Filing Feedback", content: user.feedback.comment })} />}
                      </div>
                    ) : <span className="text-sm text-gray-400">No rating</span>
                  ) : service.key === 'isBookkeepingEnabled' ? (
                    user.bookkeepingFeedback?.rating ? (
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => <FaStar key={i} className={`${i < user.bookkeepingFeedback.rating ? "text-yellow-400" : "text-gray-300"} w-3.5 h-3.5`} />)}
                        {user.bookkeepingFeedback.comment && <FaComment className="ml-2 text-gray-400 cursor-pointer w-3.5 h-3.5" title="View Comment" onClick={() => setFeedbackViewData({ isOpen: true, title: "Bookkeeping Feedback", content: user.bookkeepingFeedback.comment })} />}
                      </div>
                    ) : <span className="text-sm text-gray-400">No rating</span>
                  ) : <span className="text-sm text-gray-400">No rating</span>}
                </td>
                <td className="px-4 py-3 min-w-[150px]">
                  <div className="flex items-center gap-2 flex-wrap">
                    {service.key === 'isTaxFilingEnabled' ? (
                      renderStepsProgress(user._id)
                    ) : service.key === 'isUSAEnabled' ? (
                      renderUSAFormationStepsProgress(user._id)
                    ) : service.key === 'isBookkeepingEnabled' ? (
                      renderBookkeepingStepsProgress(user._id)
                    ) : (
                      "-"
                    )}
                  </div>
                </td>
                <td className="px-4 py-3 min-w-[100px]">
                  {(service.key === 'isTaxFilingEnabled' && user.assignedForm) && <button onClick={() => handlePreviewChecklist(user, -1, 'preview', 'tax')} className="px-2 py-1 text-xs font-medium border border-cyan-500 text-cyan-600 rounded-lg hover:bg-cyan-50 dark:hover:bg-cyan-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Preview</button>}
                  {service.key === 'isBookkeepingEnabled' && <button onClick={() => handlePreviewChecklist(user, -1, 'preview', 'bookkeeping')} className="px-2 py-1 text-xs font-medium border border-cyan-500 text-cyan-600 rounded-lg hover:bg-cyan-50 dark:hover:bg-cyan-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Preview</button>}
                </td>
                <td className="px-4 py-3 min-w-[100px]">
                  {(service.key === 'isTaxFilingEnabled' && user.assignedForm) && <button onClick={() => handleReviewChecklist(user, -1, 'tax')} className="px-2 py-1 text-xs font-medium border border-primary-500 text-primary-600 rounded-lg hover:bg-primary-50 dark:hover:bg-primary-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Review</button>}
                  {service.key === 'isBookkeepingEnabled' && <button onClick={() => handleReviewChecklist(user, -1, 'bookkeeping')} className="px-2 py-1 text-xs font-medium border border-primary-500 text-primary-600 rounded-lg hover:bg-primary-50 dark:hover:bg-primary-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Review</button>}
                </td>
                <td className="px-4 py-3 text-sm text-gray-500 min-w-[120px] sticky right-0 bg-gray-50 dark:bg-dark-700/50">-</td>
              </tr>
            )
          ))}

          {/* Member rows */}
          {user.members?.map((member, memberIndex) => (
            <tr 
              key={`${user._id}-member-${memberIndex}`} 
              onClick={(e) => handleRowClick(user, 'member', e, memberIndex)}
              className="bg-blue-50/30 dark:bg-blue-900/5 border-b border-gray-100 dark:border-dark-700 transition-colors hover:bg-blue-100/50 dark:hover:bg-blue-900/30 cursor-pointer"
            >

              {selectionMode && <td className="px-4 py-3 w-12"></td>}
              <td className="pl-4 pr-1 py-1 w-12"></td>

              <td className="px-4 py-3 min-w-[250px]">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300 pl-4 border-l-2 border-primary-400 dark:border-primary-500">
                  {(() => {
                    const name = member.name || `Member ${memberIndex + 1}`;
                    return name.toLowerCase().includes('tax filing') ? name : `${name} - Tax Filing`;
                  })()}
                </span>
              </td>
              <td className="px-4 py-3 w-20">
                {member.paymentStatus === 'wip-unpaid' ? (
                  <span className="px-2 py-1 text-[10px] font-bold bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 rounded-full whitespace-nowrap">WIP-Unpaid</span>
                ) : member.paymentStatus === 'p-extension' ? (
                  <span className="px-2 py-1 text-[10px] font-bold bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400 rounded-full whitespace-nowrap">P Extension</span>
                ) : member.paymentStatus === 'up-extension' ? (
                  <span className="px-2 py-1 text-[10px] font-bold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400 rounded-full whitespace-nowrap">UP Extension</span>
                ) : member.taxFilingLocked ? (
                  <span className="px-2 py-1 text-[10px] font-bold bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 rounded-full whitespace-nowrap">Unpaid</span>
                ) : (
                  <span className="px-2 py-1 text-[10px] font-bold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 rounded-full whitespace-nowrap">Paid</span>
                )}
              </td>
              <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 min-w-[120px]">{getAssignedEmployee(user._id)}</td>
              <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 min-w-[150px]">Tax Filing</td>
              <td className="px-4 py-3 min-w-[100px]">{member.assignedForm ? <span className="px-2 py-1 text-xs font-medium bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400 rounded-full">{member.assignedForm}</span> : <span className="text-sm text-gray-400">Not assigned</span>}</td>
              <td className="px-4 py-3 min-w-[150px]">
                {member.feedback?.rating ? (
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className={`${i < member.feedback.rating ? "text-yellow-400" : "text-gray-300"} w-3.5 h-3.5`} />
                    ))}
                    {member.feedback.comment && (
                      <FaComment
                        className="ml-2 text-gray-400 cursor-pointer w-3.5 h-3.5"
                        title="View Comment"
                        onClick={() => setFeedbackViewData({ isOpen: true, title: `Member Feedback - ${member.name}`, content: member.feedback.comment })}
                      />
                    )}
                  </div>
                ) : (
                  <span className="text-sm text-gray-400">No rating</span>
                )}
              </td>
              <td className="px-4 py-3 min-w-[150px]">
                <div className="flex items-center gap-2 flex-wrap">
                  {user.isTaxFilingEnabled ? renderStepsProgress(user._id, memberIndex) : "-"}
                </div>
              </td>
              <td className="px-4 py-3 min-w-[100px]">{user.isTaxFilingEnabled && member.assignedForm && <button onClick={() => handlePreviewChecklist(user, memberIndex, 'preview', 'tax')} className="px-2 py-1 text-xs font-medium border border-cyan-500 text-cyan-600 rounded-lg hover:bg-cyan-50 dark:hover:bg-cyan-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Preview</button>}</td>
              <td className="px-4 py-3 min-w-[100px]">{user.isTaxFilingEnabled && member.assignedForm && <button onClick={() => handleReviewChecklist(user, memberIndex, 'tax')} className="px-2 py-1 text-xs font-medium border border-primary-500 text-primary-600 rounded-lg hover:bg-primary-50 dark:hover:bg-primary-900/20 flex items-center gap-1 whitespace-nowrap"><FaClipboardCheck /> Review</button>}</td>
              <td className="px-4 py-3 min-w-[120px] sticky right-0 bg-blue-50/50 dark:bg-blue-900/10">-</td>
            </tr>
          ))}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="pt-0 px-0 pb-6">

      {/* Page Header */}
      <PageHeader
        title="Client Management"
        description={`${filteredUsers?.length ?? 0} clients found`}
        icon={FaUsers}
        className="mb-4 px-1"
        actions={
          <>
            {/* Search Input */}
            <div className="relative w-64 mr-2">
              <FaSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 w-3.5 h-3.5 pointer-events-none" />
              <input
                type="text"
                placeholder="Search by name, email or client ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-white dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-sm text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 transition-all shadow-sm"
              />
            </div>

            {/* Selection Mode Button */}
            <button
              onClick={() => setSelectionMode(!selectionMode)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-xl transition-all ${
                selectionMode
                  ? "bg-primary-600 text-white shadow-lg shadow-primary-500/30 hover:bg-primary-700"
                  : "bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-dark-600"
              }`}
            >
              <FaUserSecret className={`w-3.5 h-3.5 ${selectionMode ? "animate-pulse" : ""}`} />
              {selectionMode ? "Selection Active" : "Selection Mode"}
            </button>

            {/* Filters Toggle Button */}
            <button
              onClick={() => setShowFiltersPanel(!showFiltersPanel)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-xl transition-all ${
                showFiltersPanel
                  ? "bg-primary-600 text-white shadow-lg shadow-primary-500/30 hover:bg-primary-700"
                  : "bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-dark-600"
              }`}
            >
              <FaFilter className="w-3.5 h-3.5" />
              Filters
              {showFiltersPanel
                ? <FaChevronUp className="w-3 h-3" />
                : <FaChevronDown className="w-3 h-3" />}
            </button>
          </>
        }
      />

      {loading ? (
        <SkeletonLoader variant="table" rows={8} cols={11} />
      ) : error ? (
        <div className="p-4 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 rounded-xl">{error}</div>
      ) : (
        <>
          {showFiltersPanel && (
            <ClientFilters
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              employeeFilter={employeeFilter}
              setEmployeeFilter={setEmployeeFilter}
              employees={employees}
              stepFilter={stepFilter}
              setStepFilter={setStepFilter}
              paymentFilter={paymentFilter}
              setPaymentFilter={setPaymentFilter}
              serviceFilter={serviceFilter}
              setServiceFilter={setServiceFilter}
              taxYearStart={taxYearStart}
              setTaxYearStart={setTaxYearStart}
              taxYearEnd={taxYearEnd}
              setTaxYearEnd={setTaxYearEnd}
              dueDateStart={dueDateStart}
              setDueDateStart={setDueDateStart}
              dueDateEnd={dueDateEnd}
              setDueDateEnd={setDueDateEnd}
              selectionMode={selectionMode}
              setSelectionMode={setSelectionMode}
              ratingFilter={ratingFilter}
              setRatingFilter={setRatingFilter}
              onExportExcel={() => handleExportExcel('filtered')}
            />
          )}


          <div className="mt-6 bg-white dark:bg-dark-800 rounded-2xl shadow-sm border border-gray-100 dark:border-dark-700 overflow-hidden">
            <div className="overflow-x-auto overflow-y-visible">


              <table className="w-full min-w-max">
                <thead className="bg-gray-50 dark:bg-dark-700">
                  <tr>
                    {selectionMode && (
                      <th className="px-4 py-3 text-left w-12">
                        <input
                          type="checkbox"
                          checked={filteredUsers.length > 0 && filteredUsers.every(u => selectedIds.includes(u._id))}
                          onChange={toggleSelectAll}
                          className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                        />
                      </th>
                    )}
                    <th className="pl-4 pr-1 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase w-12">No.</th>

                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[250px]">Client Information</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[100px]">P / U</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[120px]">Emp.Assign</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[150px]">Service</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[100px]">Form</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[150px]">Rating</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[150px]">Steps</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[100px]">Preview</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[100px]">Review</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase min-w-[120px] sticky right-0 bg-gray-50 dark:bg-dark-700">Actions</th>
                  </tr>
                </thead>
                <tbody>{renderClientRows()}</tbody>
              </table>
            </div>
          </div>

          {selectionMode && (
            <div className="flex flex-wrap justify-between items-center gap-4 mt-6 px-6 animate-in fade-in slide-in-from-bottom-2 duration-300">

              <div className="flex flex-wrap gap-2 items-center">
                <button onClick={handleDownloadReport} className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white font-medium rounded-xl hover:bg-green-700 shadow-md">
                  <FaDownload /> Download Report
                </button>

                <button
                  type="button"
                  onClick={handleExportExcel}
                  disabled={selectedIds.length === 0}
                  className="flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white font-semibold rounded-xl hover:bg-emerald-700 shadow-md shadow-emerald-600/20 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  title="Export selected client services & due dates to Excel"
                >
                  <FaFileExcel className="w-4 h-4 text-emerald-100" />
                  Export Excel ({selectedIds.length})
                </button>

                <button onClick={openEmailModal} disabled={selectedIds.length === 0} className="flex items-center gap-2 px-4 py-2 bg-cyan-600 text-white font-medium rounded-xl hover:bg-cyan-700 disabled:opacity-50">
                  Send Email ({selectedIds.length})
                </button>

                <button onClick={() => { setExportUser(null); setIsAllExport(true); setShowExportModal(true); }} className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white font-medium rounded-xl hover:bg-purple-700">
                  <FaDownload /> Export All Platform Data
                </button>
              </div>
              <button onClick={openHistory} className="px-4 py-2 border border-gray-300 dark:border-dark-600 text-gray-700 dark:text-gray-300 font-medium rounded-xl hover:bg-gray-50 dark:hover:bg-dark-700">
                View Email History
              </button>
            </div>
          )}


          <ClientPagination currentPage={currentPage} totalPages={totalPages} paginate={paginate} filteredUsers={filteredUsers} clientsPerPage={clientsPerPage} indexOfFirstClient={indexOfFirstClient} indexOfLastClient={indexOfLastClient} />
        </>
      )}

      <EditClientModal showEditModal={showEditModal} setShowEditModal={setShowEditModal} selectedUser={selectedUser} editFormData={editFormData} setEditFormData={setEditFormData} handleEditSubmit={handleEditSubmit} />

      <ClientMenuModal
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        users={users}
        onlineUserIds={onlineUserIds}
        selectedMenuUser={selectedMenuUser}
        setSelectedMenuUser={setSelectedMenuUser}
        selectedStep={selectedStep}
        setSelectedStep={setSelectedStep}
        handleFormAssignment={handleFormAssignment}
        handleMemberFormAssignment={handleMemberFormAssignment}
        handleStepSubmit={handleStepSubmit}
        handleMemberStepSubmit={handleMemberStepSubmit}
        isStepSubmitted={isStepSubmitted}
        isMemberStepSubmitted={isMemberStepSubmitted}
        canSubmitStep={canSubmitStep}
        canSubmitMemberStep={canSubmitMemberStep}
        toggleServiceLock={toggleServiceLock}
        toggleLoading={toggleLoading}
        toggleMemberSection={toggleMemberSection}
        handleMemberNameUpdate={handleMemberNameUpdate}
        addMember={addMember}
        removeMember={removeMember}
        userSteps={userSteps}
        handleUSAFormationStepSubmit={handleUSAFormationStepSubmit}
        isUSAFormationStepSubmitted={isUSAFormationStepSubmitted}
        canSubmitUSAFormationStep={canSubmitUSAFormationStep}
        handleCompanyFormAssignment={handleCompanyFormAssignment}
        handleTaxDateUpdate={handleTaxDateUpdate}
        handleMemberTaxDateUpdate={handleMemberTaxDateUpdate}
        handleHistoryTaxDateUpdate={handleHistoryTaxDateUpdate}
        handleAnnualReportServiceUpdate={handleAnnualReportServiceUpdate}
        handleRemoveAnnualReportService={handleRemoveAnnualReportService}
        handleBookkeepingServiceUpdate={handleBookkeepingServiceUpdate}
        handleRemoveBookkeepingService={handleRemoveBookkeepingService}
        handleRegisteredAgentDueDateUpdate={handleRegisteredAgentDueDateUpdate}
        handleRegisteredAgentDocumentUpload={handleRegisteredAgentDocumentUpload}
        handleRegisteredAgentDocumentDelete={handleRegisteredAgentDocumentDelete}
        handleMoveToHistory={handleMoveToHistory}
        handleUnlockTaxFiling={handleUnlockTaxFiling}
        handleUnlockAnnualReport={handleUnlockAnnualReport}
        handleAnnualReportPaymentStatusUpdate={handleAnnualReportPaymentStatusUpdate}
        handleUpdateTaxFilingUnlockPrice={handleUpdateTaxFilingUnlockPrice}
        handleUpdateTaxSummaryTable={handleUpdateTaxSummaryTable}
        handleOpenStep1Checklist={handleOpenStep1Checklist}
        handleOpenStep3CustomTable={handleOpenStep3CustomTable}
        handleViewStep3Submission={handleViewStep3Submission}
        getStep3Status={getStep3Status}
        refreshUserSteps={async (userId) => {
          await fetchUserSteps(userId);
          await fetchUserMemberSteps(userId);
        }}
        handleAnnualReportStepStatusChange={handleAnnualReportStepStatusChange}
        handleReopenAnnualReportChecklist={handleReopenAnnualReportChecklist}

        onQuickPayment={handleQuickPayment}
        onChatClick={toggleChatbox}
        chatUser={chatUser}
        setChatUser={setChatUser}
        onExportData={(user) => { setExportUser(user); setIsAllExport(false); setShowExportModal(true); }}
        onAnnualReportClick={handleAnnualReportClick}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        initialMemberIndex={menuInitialMemberIndex}
        onToggleVerify={handleToggleVerify}
        onUserUpdated={(updatedUser) => {
          setUsers(prev => prev.map((u) => u._id === updatedUser._id ? updatedUser : u));
          setFilteredUsers(prev => prev.map((u) => u._id === updatedUser._id ? updatedUser : u));
        }}
      />

      <QuickPaymentModal showModal={showQuickPaymentModal} setShowModal={setShowQuickPaymentModal} updateQuickPayment={updateQuickPayment} userId={selectedUserForPayment} />

      {/* Actions Dropdown Menu */}
      {openDropdown && dropdownUser && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpenDropdown(null)} />
          <div className="fixed top-1/2 right-8 transform -translate-y-1/2 w-48 bg-white dark:bg-dark-800 rounded-xl shadow-2xl border border-gray-200 dark:border-dark-700 z-50 py-2">
            <div className="px-4 py-2 border-b border-gray-100 dark:border-dark-700">
              <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">{dropdownUser.name}</p>
            </div>
            <button onClick={() => { toggleChatbox(dropdownUser); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700 flex items-center gap-3"><img src="/chat-icon.png" className="w-4 h-4 object-contain" alt="Chat" /> Chat</button>
            <button onClick={() => { handleInvoiceClick(dropdownUser); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700 flex items-center gap-3"><FaFileInvoice className="w-4 h-4 text-gray-400" /> Documents</button>
            <button onClick={() => { handleMenuClick(dropdownUser); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700 flex items-center gap-3"><FaCog className="w-4 h-4 text-gray-400" /> Menu</button>
            <button onClick={() => { handleToggleVerify(dropdownUser._id); setOpenDropdown(null); }} className={`w-full px-4 py-2.5 text-left text-sm flex items-center gap-3 ${dropdownUser.isVerified ? 'text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20' : 'text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20'}`}>
              <FaUserShield className="w-4 h-4" />
              {dropdownUser.isVerified ? 'Block / Unverify User' : 'Unblock / Verify User'}
            </button>
            <div className="border-t border-gray-100 dark:border-dark-700 my-1" />
            <button onClick={() => { handleImpersonateUser(dropdownUser._id, dropdownUser.name); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-left text-sm text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 flex items-center gap-3"><FaUserSecret className="w-4 h-4" /> Login as User</button>
            <button onClick={() => { handleDelete(dropdownUser._id); setOpenDropdown(null); }} className="w-full px-4 py-2.5 text-left text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 flex items-center gap-3"><FaTrash className="w-4 h-4" /> Delete</button>
          </div>
        </>
      )}

      {/* Email Modal */}
      {showEmailModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeEmailModal}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="p-4 bg-gradient-to-r from-primary-600 to-primary-700 text-white flex items-center justify-between">
              <h2 className="text-lg font-bold">Send Email to Selected Clients</h2>
              <button onClick={closeEmailModal} className="p-2 hover:bg-white/10 rounded-lg"><FaTimes /></button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Subject</label>
                <input type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} placeholder="Enter subject" className="w-full px-4 py-2.5 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Message</label>
                <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg mb-3 text-sm text-blue-700 dark:text-blue-400">
                  <strong>Personalization:</strong> Use <code className="bg-blue-100 dark:bg-blue-900/40 px-1 rounded">$name</code> to insert client's name.
                </div>
                <div className="border border-gray-200 dark:border-dark-600 rounded-xl overflow-hidden" style={{ minHeight: '350px' }}>
                  <ReactQuill ref={quillRef} theme="snow" value={emailBody} onChange={setEmailBody} modules={modules} formats={formats} style={{ height: '280px' }} placeholder="Type your message..." />
                </div>
              </div>
            </div>
            <div className="p-4 border-t border-gray-100 dark:border-dark-700 bg-gray-50 dark:bg-dark-700/50">
              {sending && (
                <div className="mb-4">
                  <div className="flex justify-between text-sm text-primary-600 font-medium mb-1"><span>Sending emails...</span><span>{sendProgress}%</span></div>
                  <div className="h-2 bg-gray-200 dark:bg-dark-600 rounded-full overflow-hidden"><div className="h-full bg-primary-600 transition-all" style={{ width: `${sendProgress}%` }} /></div>
                </div>
              )}
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-500">{selectedIds.length} client(s) selected</span>
                <div className="flex gap-2">
                  <button onClick={closeEmailModal} disabled={sending} className="px-4 py-2 text-gray-700 dark:text-gray-300 font-medium rounded-xl hover:bg-gray-100 dark:hover:bg-dark-600 disabled:opacity-50">Cancel</button>
                  <button onClick={sendBulkEmail} disabled={sending} className="px-6 py-2 bg-primary-600 text-white font-medium rounded-xl hover:bg-primary-700 disabled:opacity-50">{sending ? 'Sending...' : 'Send Email'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* History Modal */}
      {showHistory && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShowHistory(false)}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="p-4 border-b border-gray-100 dark:border-dark-700 flex items-center justify-between">
              <h2 className="text-lg font-bold text-gray-900 dark:text-white">Email Send History</h2>
              <button onClick={() => setShowHistory(false)} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg"><FaTimes /></button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
              {historyLoading ? (
                <div className="flex justify-center py-10"><div className="w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" /></div>
              ) : historyError ? (
                <div className="p-4 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 rounded-xl">{historyError}</div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 dark:bg-dark-700">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">Date</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">Subject</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">Recipients</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">Sent/Total</th>
                        <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emailLogs.length === 0 ? (
                        <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-500">No email logs found.</td></tr>
                      ) : emailLogs.map((log) => {
                        const sentCount = (log.result || []).filter(r => r.status === 'sent').length;
                        const total = (log.result || []).length;
                        const recipients = (log.recipients || []).join(', ');
                        return (
                          <tr key={log._id} className="border-b border-gray-100 dark:border-dark-700">
                            <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">{new Date(log.createdAt || log.sentAt).toLocaleString()}</td>
                            <td className="px-4 py-3 text-sm text-gray-900 dark:text-white font-medium">{log.subject}</td>
                            <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400 max-w-[200px] truncate" title={recipients}>{recipients}</td>
                            <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400">{sentCount} / {total}</td>
                            <td className="px-4 py-3 text-right sticky right-0 bg-white dark:bg-dark-800">
                              <button
                                onClick={() => handleDeleteEmailLog(log._id)}
                                className="p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                                title="Delete History"
                              >
                                <FaTrash className="w-3.5 h-3.5" />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {chatUser && <Chatbox user={chatUser} onClose={() => setChatUser(null)} />}

      <ChecklistModal show={showChecklistModal} onHide={() => setShowChecklistModal(false)} userId={checklistUser?._id} memberIndex={checklistMemberIndex} formType={checklistFormType} mode={checklistMode} />

      <AdminStep1ChecklistModal
        show={showStep1ChecklistModal}
        onClose={() => { setShowStep1ChecklistModal(false); setStep1ChecklistUser(null); setStep1ChecklistMemberIndex(-1); }}
        userId={step1ChecklistUser?._id}
        memberIndex={step1ChecklistMemberIndex}
        onSaved={() => {
          // Refresh user steps after admin saves
          if (step1ChecklistUser?._id) {
            fetchUserSteps(step1ChecklistUser._id);
            fetchUserMemberSteps(step1ChecklistUser._id);
          }
        }}
      />

      <Step3CustomTableModal
        isOpen={showStep3CustomTableModal}
        onClose={() => { setShowStep3CustomTableModal(false); setStep3IsEditMode(false); setStep3User(null); setStep3MemberIndex(null); setStep3CustomTable(null); }}
        userId={step3User?._id}
        memberIndex={step3MemberIndex}
        onSave={handleSaveStep3CustomTable}
        existingTable={step3CustomTable}
        isEditMode={step3IsEditMode}
      />

      <Step3SubmittedDataModal
        isOpen={showStep3SubmittedDataModal}
        onClose={() => { setShowStep3SubmittedDataModal(false); setStep3User(null); setStep3MemberIndex(null); setStep3CustomTable(null); }}
        customTable={step3CustomTable}
        onMarkCompleted={handleMarkStep3Completed}
        onEditTable={handleEditStep3Table}
        step3Status={step3User ? getStep3Status(step3User._id, step3MemberIndex) : null}
      />

      <ExportUserModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        user={exportUser}
        isAllExport={isAllExport}
        selectedUserIds={isAllExport ? selectedIds : []}
      />

      {/* Feedback View Modal */}
      {feedbackViewData.isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setFeedbackViewData({ ...feedbackViewData, isOpen: false })} />
          <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
            <div className="p-4 bg-gradient-to-r from-primary-600 to-cyan-500 text-white flex items-center justify-between">
              <h2 className="text-lg font-bold flex items-center gap-2">
                <FaStar className="text-yellow-300" /> {feedbackViewData.title}
              </h2>
              <button
                onClick={() => setFeedbackViewData({ ...feedbackViewData, isOpen: false })}
                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
              >
                <FaTimes />
              </button>
            </div>
            <div className="p-6">
              <div className="bg-gray-50 dark:bg-dark-700/50 p-4 rounded-xl border border-gray-100 dark:border-dark-600">
                <p className="text-gray-700 dark:text-gray-300 italic leading-relaxed whitespace-pre-wrap">
                  "{feedbackViewData.content}"
                </p>
              </div>
              <div className="mt-6 flex justify-end">
                <button
                  onClick={() => setFeedbackViewData({ ...feedbackViewData, isOpen: false })}
                  className="px-6 py-2 bg-primary-600 text-white font-medium rounded-xl hover:bg-primary-700 transition-colors shadow-lg shadow-primary-500/20"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete User Confirmation Modal */}
      {showDeleteModal && userToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowDeleteModal(false)} />
          <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
            <div className="p-6">
              <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaTrash className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2">Delete User</h3>
              <p className="text-gray-500 dark:text-gray-400 text-center text-sm mb-6">
                Are you sure you want to delete <span className="font-bold text-gray-900 dark:text-white">{userToDelete.name}</span>? This action will move all user data to the Recycle Bin.
              </p>

              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
                    Type the User Name to confirm
                  </label>
                  <input
                    type="text"
                    value={deleteConfirmationName}
                    onChange={(e) => setDeleteConfirmationName(e.target.value)}
                    placeholder={userToDelete.name}
                    className="w-full px-4 py-3 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white placeholder-gray-400 focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
                  />
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    className="flex-1 px-4 py-3 bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 font-bold rounded-xl hover:bg-gray-200 dark:hover:bg-dark-600 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmDelete}
                    disabled={deleteConfirmationName !== userToDelete.name}
                    className="flex-1 px-4 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-red-600/20"
                  >
                    Delete User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Member Confirmation Modal */}
      {showMemberDeleteModal && memberToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowMemberDeleteModal(false)} />
          <div className="relative bg-white dark:bg-dark-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
            <div className="p-6">
              <div className="w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaTrash className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2">Delete Member</h3>
              <p className="text-gray-500 dark:text-gray-400 text-center text-sm mb-6">
                Are you sure you want to delete <span className="font-bold text-gray-900 dark:text-white">{memberToDelete.name}</span>? This action will move all member data to the Recycle Bin.
              </p>

              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
                    Type the Member Name to confirm
                  </label>
                  <input
                    type="text"
                    value={memberDeleteConfirmationName}
                    onChange={(e) => setMemberDeleteConfirmationName(e.target.value)}
                    placeholder={memberToDelete.name}
                    className="w-full px-4 py-3 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-xl text-gray-900 dark:text-white placeholder-gray-400 focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
                  />
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setShowMemberDeleteModal(false)}
                    className="flex-1 px-4 py-3 bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 font-bold rounded-xl hover:bg-gray-200 dark:hover:bg-dark-600 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmMemberDelete}
                    disabled={memberDeleteConfirmationName !== memberToDelete.name}
                    className="flex-1 px-4 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-red-600/20"
                  >
                    Delete Member
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Export Excel Selection Modal */}
      <ExportExcelModal
        isOpen={showExcelModal}
        onClose={() => setShowExcelModal(false)}
        filteredUsers={filteredUsers}
        allUsers={users}
        selectedIds={selectedIds}
        employees={employees}
        serviceFilter={serviceFilter}
      />
    </div>
  );
};
export default ClientManagement;